import { useChatStore } from '@/stores/chatStore';
import { cn } from '@/lib/utils';

export default function ChatModeToggle() {
  const mode = useChatStore(s => s.mode);
  const setMode = useChatStore(s => s.setMode);

  return (
    <div className="flex items-center bg-slate-100 rounded-full p-0.5 text-xs">
      <button
        onClick={() => setMode('support')}
        className={cn(
          'px-2 py-0.5 rounded-full transition-colors',
          mode === 'support'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700',
        )}
      >
        Support
      </button>
      <button
        onClick={() => setMode('analysis')}
        className={cn(
          'px-2 py-0.5 rounded-full transition-colors',
          mode === 'analysis'
            ? 'bg-white text-slate-900 shadow-sm'
            : 'text-slate-500 hover:text-slate-700',
        )}
      >
        Analysis
      </button>
    </div>
  );
}
